import React, { Suspense, useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ThemeProvider, CssBaseline } from "@mui/material";
import { ThemeProvider as EmotionThemeProvider } from "@emotion/react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import theme from "./theme/theme";
import Layout from "./components/Layout/Layout";
import { routes, Loading } from "./routes";
import KANAALoader from "./components/Loader/Loader";
import ScrollToTop from "./components/ScrollToTop";

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 3000);
    return () => clearTimeout(timer);
  }, []);

  if (loading) {
    return <KANAALoader />;
  }
  return (
    <ThemeProvider theme={theme}>
      <EmotionThemeProvider theme={theme}>
        <CssBaseline />
        <ToastContainer position="top-right" autoClose={4000} hideProgressBar={false} />
        <Router>
          <ScrollToTop />
          <Layout>
            <Suspense fallback={<Loading />}>
              <Routes>
                {routes.map((route, index) =>
                  <Route
                    key={index}
                    path={route.path}
                    element={route.element}
                  />
                )}
              </Routes>
            </Suspense>
          </Layout>
        </Router>
      </EmotionThemeProvider>
    </ThemeProvider>
  );
}

export default App;
